export type OpenAssistantOptions = {
  prompt?: string;
};

export const OPEN_ASSISTANT_EVENT = 'ai-assistant:open';

export const openAssistant = (opts: OpenAssistantOptions = {}) => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(OPEN_ASSISTANT_EVENT, { detail: opts }));
};

export const CLOSE_ASSISTANT_EVENT = 'ai-assistant:close';

export const TOGGLE_ASSISTANT_EVENT = 'ai-assistant:toggle';

export const toggleAssistant = () => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(TOGGLE_ASSISTANT_EVENT));
};
